import React, { useRef } from 'react';
import styled from 'styled-components';

import useProductsImport from 'core/hooks/useProductsImport';
import LoadingButton from 'Elements/Form/LoadingButton';

const HiddenInput = styled.input`
  display: none;
`;

function ProductImportButton() {
  const { importProducts, loading } = useProductsImport();
  const ref = useRef<HTMLInputElement>(null);

  const selectFile = () => ref.current && ref.current.click();

  const handleChange: React.FormEventHandler<HTMLInputElement> = (event) => {
    if (event.currentTarget.files != null) {
      importProducts(event.currentTarget.files[0]);
    }
  };

  return (
    <>
      <LoadingButton
        variant="contained"
        color="secondary"
        onClick={selectFile}
        loading={loading}
      >
        Vie tuotelista
      </LoadingButton>

      <HiddenInput type="file" ref={ref} onChange={handleChange} />
    </>
  );
}

export default ProductImportButton;
